const STORAGE_KEY = "approverReturnTo";
// Only a same-origin path into the approver is ever honoured
const APPROVER_PATH = /^\/approver(\/|$)/;

/**
 * Stashes the `returnTo` target the approver app sends a signed-out user here
 * with, so they can be handed back to it once signed in. sessionStorage on
 * purpose: it survives the redirect to CIAM and back within the tab, never
 * leaks into other tabs and a stale value dies with the tab.
 */
export const rememberApproverReturn = (search: string): void => {
  const target = new URLSearchParams(search).get("returnTo");
  if (target && APPROVER_PATH.test(target)) {
    try {
      sessionStorage.setItem(STORAGE_KEY, target);
    } catch {
      // Storage is blocked in this browser: the user lands on the home page
      // as before instead of the bootstrap failing
    }
  }
};

/**
 * Returns the stashed approver target and forgets it, so a value is only ever
 * honoured once.
 */
export const takeApproverReturn = (): string | undefined => {
  try {
    const target = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return target && APPROVER_PATH.test(target) ? target : undefined;
  } catch {
    return undefined;
  }
};
